import { faSort, faSortDown, faSortUp } from '@fortawesome/pro-solid-svg-icons';
import { StyledSortIcon } from 'components/infinite_data_source_table/styled';

type TableSortIconProps = Readonly<{
    /**
     * Whether this column is currently sorted
     */
    isSorted?: boolean;
    /**
     * The current sort direction if sorted
     */
    direction?: 'asc' | 'desc';
}>;

export function TableSortIcon({ isSorted, direction }: TableSortIconProps) {
    const sortIcon = isSorted ? (direction === 'asc' ? faSortUp : faSortDown) : faSort;

    return <StyledSortIcon icon={sortIcon} $isSorted={isSorted} />;
}
